<script>
import ProjectActionCategoryService from "@/services/ProjectActionCategoryService";
import Cloner from "@/libraries/Cloner";

export default {
    props: {
        projectId: {},
        projectActionCategoryId: {},
        projectMomId: {}
    },
    data() {
        return {
            loading: true,
            editing: false,
            saving: false,
            cats: [],
            errors: {},
            entity: {
                id: null,
                name: null,
                project_id: null,
                project_mom_id: null
            }
        };
    },
    async created() {
        this.editing = false;
        this.entity.project_id = this.projectId;
        if (this.projectMomId) {
            this.entity.project_mom_id = this.projectMomId;
        }
        // Figure out if we are editing
        if (typeof this.projectActionCategoryId !== "undefined") {
            console.log("WE ARE EDITING");
            await this.fetchData();
            this.editing = true;
        }

        this.loading = false;
    },
    mounted() {
        this.$nextTick(() => {
            const input = this.$refs.firstInput?.$el.querySelector("input");
            if (input) input.focus();
        });
    },
    methods: {
        async fetchData() {
            try {
                const { data } = await ProjectActionCategoryService.GETS(
                    this.projectActionCategoryId
                );
                console.log("DATA", data);
                this.entity = Cloner.pickClone(data.data, [
                    "id",
                    "project_id",
                    "name"
                ]);
            } catch (e) {
                console.log("exc fetch data", e);
            }
        },
        async saveForm() {
            try {
                this.saving = true;
                if (this.editing) {
                    await ProjectActionCategoryService.PUT(this.entity);
                    this.$emit("close-renamed", { name: this.entity.name });
                } else {
                    await ProjectActionCategoryService.POST(this.entity);
                    this.$emit("close-reload");
                }
            } catch (e) {
                this.errors = e.response.data.errors;
            }

            this.saving = false;
        }
    }
};
</script>

<template>
    <modal
        :show="true"
        @close="$emit('close')"
        class="budget-modal"
        :loading="loading"
    >
        <template slot="header">
            <template v-if="editing"
                >{{ $t("project_actions.edit_category") }}
            </template>
            <template v-else>{{ $t("project_actions.add_category") }}</template>
        </template>

        <template slot="default">
            <FormulateForm v-model="entity" @submit="saveForm" :errors="errors">
                <div class="row">
                    <div class="col-12">
                        <FormulateInput
                            type="text"
                            ref="firstInput"
                            name="name"
                            :label="$t('project_actions.category_name')"
                            :validation-name="
                                $t('project_actions.category_name')
                            "
                            validation="required"
                        />
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col text-right">
                        <base-button
                            type="secondary"
                            :outline="true"
                            @click="$emit('close')"
                            >{{ $t("cancel") }}</base-button
                        >
                        <base-button
                            type="primary"
                            :loading="saving"
                            native-type="submit"
                            >{{ $t("save") }}</base-button
                        >
                    </div>
                </div>
            </FormulateForm>
        </template>
    </modal>
</template>
